<div class="alpr-license-plate">
  <!-- License Plate Display -->
  <div class="plate-section">
    <span class="plate-number">{{ plateNumber }}</span>
    <sn-icon class="copy-icon" (click)="onCopyPlate()" matTooltip="Copy plate number">
      content_copy
    </sn-icon>
    <span class="plate-state">{{ plateState }}</span>
  </div>

  <!-- Image Placeholder Section -->
  <div class="image-section" *ngIf="plateImageUrl">
    <ng-container *ngIf="hasImage; else noImageTemplate">
      <img
        [src]="plateImageUrl"
        class="alert-image"
        alt="{{ 'alpr.licensePlate.closeUpAlt' | t }}"
        loading="lazy"
      />
    </ng-container>
    <ng-template #noImageTemplate>
      <div class="image-placeholder">
        <div class="placeholder-text">Not provided<br />by {{ providerName }}</div>
      </div>
    </ng-template>
  </div>

  <!-- Search Button -->
  <div class="search-section">
    <button
      mat-stroked-button
      class="search-button"
      (click)="onSearchPlate()"
      [disabled]="plateNumber === '— — — — — — —'"
    >
      {{ 'alpr.licensePlate.searchThisPlate' | t }}
    </button>
  </div>
</div>
